import SelectedJob from "@components/MobileSelectedJob";
import React, { useState } from "react";
import { use100vh } from "react-div-100vh";
import Modal from "react-modal";

let customStyles = {
  content: {
    height: "100vh",
    width: "100vw",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    padding: "0",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflowY: "hidden",
    borderRadius: "0",
    border: "none",
  },
  overlay: {
    zIndex: 10,
  },
};

Modal.setAppElement("#body");

export default function MobileJobDescriptionModal({ closeModal, selectedJob, dashboardPage }) {
  const [scrollTop, setScrollTop] = useState(0);

  const height = use100vh();
  customStyles.content.height = `${height}px`;

  const handleScroll = (e) => {
    setScrollTop(e.currentTarget.scrollTop);
  };

  return (
    <Modal isOpen={true} style={customStyles} contentLabel="Example Modal">
      <div style={{ overflowY: "scroll", height }} onScroll={handleScroll}>
        <SelectedJob
          selectedJob={selectedJob}
          setSelected={closeModal}
          scrollHeight={scrollTop}
          dashboardPage={dashboardPage}
        />
      </div>
    </Modal>
  );
}
